import React, { useState } from 'react';
import './Food.css';


const Food = () => {
    const [activeTab, setActiveTab] = useState('Overview');

    const data = [
        {
            SNo: '1',
            order: '123456',
            date: '27/03/202',
            Category: 'Food',
            name: 'Rahul',
            payment: 'UPI',
            status: '₹success',
            Amount: '500',
            Feedback: 'Good',
            Ratings: '*****',
            Actions: '',
        },

    ]
    // {=======================overview===============================}
    const tabContent = {
        Overview:
            <div style={{ scrollbarWidth: 'none' }}>
                <div className="status-overview">
                    <div style={{ background: "#3498db", color: "#fff" }} className="status-card dine-in">
                        <h4 style={{ display: 'flex', justifyContent: "center" }}>Dine In</h4>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Total: 20</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Active: 12</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pending: 4</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Closed: 4</p>

                    </div>
                    <div style={{ background: "#ff6347", color: "#fff" }} className="status-card dine-in">
                        <h4 style={{ display: 'flex', justifyContent: "center" }}>Pick Up</h4>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Total: 20</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Active: 12</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pending: 4</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Closed: 4</p>

                    </div>
                    <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                        <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Total: 20</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Active: 12</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Pending: 4</p>
                        <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Closed: 4</p>
                    </div>


                </div>
                <div style={{ display: "flex", gap: "10px", justifyContent: "space-between", }}>
                    <div>
                    <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                        <option value="yearly">Yearly</option>
                        <option value="yearly">2023</option>
                        <option value="yearly">2024</option>
                        <option value="yearly">2025</option>
                    </select>
                    <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                        <option value="yearly">Monthly</option>
                        <option value="yearly">Jan</option>
                        <option value="yearly">Feb</option>
                        <option value="yearly">Mar</option>
                    </select>
                    <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                        <option value="yearly">Weekly</option>
                        <option value="yearly">sun</option>
                        <option value="yearly">Mon</option>
                        <option value="yearly">Tues</option>
                    </select>
                    <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
                        <option value="yearly">Today</option>
                        <option value="yearly">Yesterday</option>
                        <option value="yearly">25/03/25</option>
                        <option value="yearly">24/03/25</option>
                    </select>
                    </div>
                    <button style={{ height: '35px', marginTop: "20px", borderRadius: "4px", border: "none", backgroundColor: "#b15cd6", color: "white", fontWeight: 'bold',}}>Export</button>
                </div>

                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                            <th style={tableHeaderStyle}>S.No</th>
                            <th style={tableHeaderStyle}>Order ID</th>
                            <th style={tableHeaderStyle}>Date</th>
                            <th style={tableHeaderStyle}>Catergory</th>
                            <th style={tableHeaderStyle}> Name</th>
                            <th style={tableHeaderStyle}>Payment</th>
                            <th style={tableHeaderStyle}>status</th>
                            <th style={tableHeaderStyle}>Amount</th>
                            <th style={tableHeaderStyle}>Feedback</th>
                            <th style={tableHeaderStyle}>Ratings</th>
                            <th style={tableHeaderStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                <td style={tableCellStyle}>{item.SNo}</td>
                                <td style={tableCellStyle}>{item.order}</td>
                                <td style={tableCellStyle}>{item.date}</td>
                                <td style={tableCellStyle}>{item.Category}</td>
                                <td style={tableCellStyle}>{item.name}</td>
                                <td style={tableCellStyle}>{item.payment}</td>
                                <td style={tableCellStyle}>{item.status}</td>
                                <td style={tableCellStyle}>{item.Amount}</td>
                                <td style={tableCellStyle}>{item.Feedback}</td>
                                <td style={tableCellStyle}>{item.Ratings}</td>
                                <td style={tableCellStyle}>{item.Actions}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>,


        // {=======================all===============================}

        All:
            <div className="status-overview">
                <div style={{ background: "#3498db", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Dine</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Accepted
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#ff6347", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Pick Up</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Accepted
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Accepted
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>

                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Accepted
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
            </div>,


        // {=======================Delivery===============================}

        Delivered:
            <div className="status-overview">
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Delivered
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Delivered
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Delivered
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Delivered
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
            </div>,




        // {=======================pending===============================}
        Pending:
            <div className="status-overview">
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Pending
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Pending
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Pending
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
                <div style={{ background: "#20B2AA", color: "#fff" }} className="status-card dine-in">
                    <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                    <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                        <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                            Order Pending
                        </button>
                    </div>
                    <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

                </div>
            </div>,

        // {=======================Cancelled===============================}
        Cancelled: <div className="status-overview">
            <div style={{ background: "#E74C3C", color: "#fff" }} className="status-card dine-in">
                <h4 style={{ display: 'flex', justifyContent: "center" }}>Dine In</h4>
                <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Cancelled
                    </button>
                </div>
                <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

            </div>
            <div style={{ background: "#E74C3C", color: "#fff" }} className="status-card dine-in">
                <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Cancelled
                    </button>
                </div>
                <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

            </div>
            <div style={{ background: "#E74C3C", color: "#fff" }} className="status-card dine-in">
                <h4 style={{ display: 'flex', justifyContent: "center" }}>Delivery</h4>
                <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Cancelled
                    </button>
                </div>
                <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

            </div>
            <div style={{ background: "#E74C3C", color: "#fff" }} className="status-card dine-in">
                <h4 style={{ display: 'flex', justifyContent: "center" }}>Pick Up</h4>
                <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>Order ID: #12345</p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <button style={{ borderRadius: "10px", border: "none", fontWeight: 'bold', }}>
                        Order Cancelled
                    </button>
                </div>
                <p style={{ textDecoration: "underline", display: "flex", justifyContent: "center", cursor: "pointer", marginTop: "10px" }}>Track Order</p>

            </div>
        </div>,
    };

    return (
        <div style={{ overflowY: 'auto', height: '550px', marginTop: '30px' }}>
            {/* Tab Buttons */}
            <div style={{ gap: '10px', display: 'flex', justifyContent: 'space-evenly' }}>
                {Object.keys(tabContent).map((label) => (
                    <button
                        key={label}
                        onClick={() => setActiveTab(label)}
                        style={{
                            border: 'none',
                            borderRadius: '10px',
                            width: '80px',
                            height: '35px',
                            backgroundColor: activeTab === label ? '#b15cd6' : '#d9d9d9',
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div style={{ marginTop: '20px',  borderRadius: '8px' }}>
                {tabContent[activeTab]}
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: '#b15cd6',
    color: 'white',
};

const tableCellStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
};

const evenRowStyle = {
    backgroundColor: '#f9f9f9',
};

const oddRowStyle = {
    backgroundColor: '#fff',
};

export default Food;
